<template>
    <div class="container-fluid min-vh-100 " style="background-color: #F5F9FA;">
      <div class="row">
        <!-- Left: Login Form -->
        <div class="col-md-8 col-lg-6 d-flex flex-column justify-content-center align-items-center px-sm-5 min-vh-100">
          <div class="w-100" style="max-width: 400px;">
            <!-- Logo -->
            <div class="text-center mb-5">
              <img src="../assets/prpl-logo.svg" alt="Company Logo" class="img-fluid" style="max-height: 60px;">
            </div>
  
            <!-- Login Form -->
            <form class="px-4 py-5" @submit.prevent="login">
              <h3 class="text-center mb-5">Sign in to your account</h3>
              <div class="mb-3">
                <label for="email" class="form-label f-13 fw-600">Email</label>
                <input type="email" id="email" v-model="email" class="form-control" placeholder="Enter your email" required>
              </div>
  
              <div class="mb-3">
                <label for="password" class="form-label f-13 fw-600">Password</label>
                <div class="position-relative">
                  <input :type="showPassword ? 'text' : 'password'"  id="password" v-model="password" class="form-control" placeholder="Password" required>
                  <button @click="showPassword = !showPassword" type="button" class="btn p-0 bg-transparent position-absolute end-0 top-50 me-2 translate-middle-y border-0">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g v-if="!showPassword" opacity="0.5">
                        <path d="M1.83335 4.83082L3.00669 3.66666L18.3334 18.9933L17.1692 20.1667L14.3459 17.3433C13.2917 17.6917 12.1734 17.875 11 17.875C6.41669 17.875 2.50252 15.0242 0.916687 11C1.54919 9.38666 2.55752 7.96582 3.84085 6.83832L1.83335 4.83082ZM11 8.24999C11.7294 8.24999 12.4288 8.53972 12.9446 9.05545C13.4603 9.57117 13.75 10.2706 13.75 11C13.7505 11.3122 13.6978 11.6222 13.5942 11.9167L10.0834 8.40582C10.3778 8.30222 10.6878 8.24953 11 8.24999ZM11 4.12499C15.5834 4.12499 19.4975 6.97582 21.0834 11C20.3348 12.9002 19.0635 14.5496 17.4167 15.7575L16.115 14.4467C17.3827 13.5698 18.4051 12.3833 19.085 11C18.344 9.48737 17.1935 8.21299 15.7643 7.32173C14.335 6.43048 12.6844 5.95811 11 5.95832C10.0009 5.95832 9.02002 6.12332 8.10335 6.41666L6.69169 5.01416C8.01169 4.44582 9.46919 4.12499 11 4.12499ZM2.91502 11C3.656 12.5126 4.80652 13.787 6.23577 14.6782C7.66502 15.5695 9.31566 16.0419 11 16.0417C11.6325 16.0417 12.2559 15.9775 12.8334 15.8492L10.7434 13.75C10.1055 13.6816 9.51028 13.397 9.05666 12.9433C8.60305 12.4897 8.31839 11.8945 8.25002 11.2567L5.13335 8.13082C4.22585 8.90999 3.46502 9.88166 2.91502 11Z" fill="#403735"/>
                      </g>
                      <g v-else opacity="0.5">
                        <path d="M11 4.125C6.41667 4.125 2.5025 6.97583 0.916667 11C2.5025 15.0242 6.41667 17.875 11 17.875C15.5833 17.875 19.4975 15.0242 21.0833 11C19.4975 6.97583 15.5833 4.125 11 4.125ZM11 15.0417C9.31563 15.0417 7.665 14.5696 6.23575 13.6783C4.8065 12.787 3.656 11.5126 2.91498 10C3.65598 8.48738 4.8065 7.21299 6.23575 6.32174C7.665 5.43048 9.31563 4.95812 11 4.95832C12.6844 4.95812 14.335 5.43048 15.7643 6.32174C17.1935 7.21299 18.344 8.48738 19.085 10C18.344 11.5126 17.1935 12.787 15.7643 13.6783C14.335 14.5696 12.6844 15.0417 11 15.0417ZM11 7.33332C10.3096 7.33332 9.6476 7.60567 9.14852 8.10474C8.64945 8.60381 8.3771 9.26582 8.3771 9.95615C8.3771 10.6465 8.64945 11.3085 9.14852 11.8076C9.6476 12.3067 10.3096 12.579 11 12.579C11.6904 12.579 12.3524 12.3067 12.8515 11.8076C13.3505 11.3085 13.6229 10.6465 13.6229 9.95615C13.6229 9.26582 13.3505 8.60381 12.8515 8.10474C12.3524 7.60567 11.6904 7.33332 11 7.33332Z" fill="#403735"/>
                      </g>
                    </svg>
                  </button>
                </div>
              </div>
  
              <div class="d-flex justify-content-between align-items-center">
                <!-- <router-link to="/forgotpassword" class="f-12 fw-500 text-primary mx-auto">Forgot Password?</router-link> -->
                <button type="submit" class="btn btn-primary ms-auto px-5 py-2 f-13 fw-600 rounded-1">Login</button>
              </div>
            </form>
  
            <!-- Footer -->
            <p class="text-center f-10 mt-4 " style="font-size: 0.8rem;">
              All Rights Reserved ©{{new Date().getFullYear()}} PropertyPistol Pvt. Ltd.
            </p>
          </div>
        </div>
  
        <!-- Right: Illustration -->
        <div class="col-md-4 col-lg-6 d-none d-md-flex align-items-center justify-content-center bg-white min-vh-100 shadow-sm" style="border-radius: 60px 0 0 60px;">
          <img src="../assets//login_logo.png" alt="Analytics Illustration" class="img-fluid" style="max-height: 400px;">
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoginPage',
    data() {
      return {
        email: '',
        password: '',
        showPassword: false,
      };
    },
    methods: {
      login() {
      let email = this.email
      let password = this.password
      this.$axios.post('/central_report/login', {email, password})
        .then(res => {
          let resData = res.data.data
          this.$cookies.set('user-token', resData.token)
          this.$cookies.set('user-name', resData.name)
          this.$cookies.set('user-email', resData.email)
          this.$router.replace('/');
        })
        .catch(err => {
          this.$swal({
            title: "Login Failed",
            text: err?.response?.data?.message || "Something went wrong",
            icon: "error"
          })
        })
      }
    }
  };
  </script>
  
  <style scoped>
  /* Optional: for slight visual polish */
  .container-fluid {
    background-color: #f8f9fa;
  }
  form a {
    text-decoration: none;
  }
  form a:hover {
    text-decoration: underline;
  }

  form{
    box-shadow: 0px 1px 3px 0px #001D251A;
    border: 1px solid #E6E6E6;
    background-color: #fff;
    border-radius: 8px;
    color: #403735;
  }

  form h3{
    font-weight: 600;
    font-size: 28px;
    text-align: center;
  }

  .form-control{
    border: 1px solid #E0DEDA;
    padding: 12px;
    font-size: 13px;
    box-shadow: none;
    border-radius: 4px;
  }

  .form-control::placeholder{
    opacity: 0.5;
  }

  .form-control:focus, .form-control:focus-visible{
    border: 1px solid #403735
  }

  @media(max-width: 576px){
    form h3{
      font-size: 24px;
    }
  }
  </style>
  